// modifer: styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionCommentsStyle
import { section, title } from 'styles/jss/original/base';

const styles = {
  section: {
    ...section,
    paddingBottom: '0'
  },
  title: {
    ...title,
    marginBottom: '30px',
    textAlign: 'center'
  }
};

export default styles;
